import type { Rules } from '~/types/permissions';
import type AuthUser from '~/types/authUser';
export type RoleWithUniversalRules = {
  name: string;
  rules: Rules[];
};
export type RolesWithUniversalRulesArray = RoleWithUniversalRules[];
export function getUniversalPermissionsFromRole(user: AuthUser): Rules[] {
  const rolesWithRules: RolesWithUniversalRulesArray = [
    {
      name: 'superadmin',
      rules: [['manage', 'All']]
    },
    {
      name: 'admin',
      rules: [
        [
          'manage',
          'User',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        ['manage', 'Company', { id: user.companyId }],
        ['read', 'Plan'],
        ['read', 'Module'],
        ['manage', 'PlanSubscription', { companyId: user.companyId }],
        [
          'manage',
          'uiRole',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        [
          'view',
          'uiRole',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        ['read', 'Tutorial']
      ]
    },
    {
      name: 'supervisor',
      rules: [
        [
          'manage',
          'User',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    roleName: 'collaborator',
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        ['view', 'Company', { id: user.companyId }],
        ['read', 'Company', { id: user.companyId }],
        ['read', 'Plan'],
        ['read', 'Module'],
        ['read', 'PlanSubscription', { companyId: user.companyId }],
        [
          'manage',
          'uiRole',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    roleName: 'collaborator',
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        [
          'view',
          'uiRole',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId,
                    default: true
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        ['read', 'Tutorial']
      ]
    },
    {
      name: 'collaborator',
      rules: [
        ['view', 'User', { id: user.id }],
        ['read', 'User', { id: user.id }],
        ['update', 'User', { id: user.id }],
        ['view', 'Company', { id: user.companyId }],
        ['read', 'Company', { id: user.companyId }],
        ['read', 'Plan'],
        ['read', 'PlanSubscription', { companyId: user.companyId }],
        ['read', 'Module'],
        ['read', 'PeriodicalFee'],
        ['update', 'UIRole', { id: user.id }],
        ['read', 'UIRole'],
        ['read', 'Tutorial']
      ]
    },
    {
      name: 'auditor',
      rules: [
        [
          'view',
          'User',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        [
          'read',
          'User',
          {
            OR: [
              {
                roles: {
                  some: {
                    companyId: user.companyId
                  }
                }
              },
              { id: user.id }
            ]
          }
        ],
        ['update', 'User', { id: user.id }],
        ['read', 'Company', { id: user.companyId }],
        ['view', 'Company', { id: user.companyId }],
        ['read', 'Plan'],
        ['read', 'Module'],
        ['read', 'PlanSubscription', { companyId: user.companyId }],
        ['read', 'uiRole', { id: user.id }],
        ['update', 'uiRole', { id: user.id }],
        ['read', 'Tutorial'],
        ['read', 'CompanyPlanSelection', { companyId: user.companyId }],
        ['update', 'UIRole'] // ???
      ]
    },
    {
      name: 'guest',
      rules: [
        ['create', 'User'],
        ['read', 'Tutorial'],
        ['read', 'Plan']
      ]
    }
  ];

  return rolesWithRules.find((role) => user.roleName === role.name)?.rules || [];
}
